export default [
  { key: 'program_id', val: 'Program ID:' },
  { key: 'external_tag', val: 'External Tag:' },
  { key: 'cardholder_id', val: 'Cardholder ID:' },
  { key: 'account_id', val: 'Account ID:' },
  { key: 'processor_reference', val: 'Account Processor Reference #: ' },
];
